import React from "react";
import classNames from "classnames";
import { map } from "lodash";
import styles from "./SwitchTab.module.scss";
export function SwitchTab(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbarWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, map(props.list, function (tab) {
    var _props$activeKey;
    return /*#__PURE__*/React.createElement("span", {
      key: tab.key,
      className: classNames(styles.navItem, tab.key === ((_props$activeKey = props.activeKey) === null || _props$activeKey === void 0 ? void 0 : _props$activeKey.value) && styles.active),
      onClick: function onClick() {
        var _props$setActiveKey;
        return (_props$setActiveKey = props.setActiveKey) === null || _props$setActiveKey === void 0 ? void 0 : _props$setActiveKey.call(props, tab.key);
      }
    }, tab.name);
  })));
}